import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface NlpResult {
  keyphase: Array<string>;
  ner: NlpNerResult;
  sentiment: NlpSentimentResult;
  status: string;
  summary: string;
  webContent: NlpWebContentResult;
}

interface NlpNerResult {
  allNamesHit: Array<Array<string | number>>;
  mostRelevant: Array<string | number>;
}

interface NlpSentimentResult {
  class: string;
  hits: Array<Array<string | Array<string>>>;
  score: number;
}

interface NlpWebContentResult {
  body: string;
  head: string;
}

@Component({
  selector: 'artemis-internet-search-detail',
  templateUrl: './internet-search-detail.component.html',
  styleUrls: ['./internet-search-detail.component.scss']
})

export class InternetSearchDetailComponent implements OnInit {

  nlpResult: NlpResult;

  constructor(@Inject(MAT_DIALOG_DATA) public data: NlpResult,
              private dialogRef: MatDialogRef<any>) {
    this.nlpResult = data;
  }

  ngOnInit() {
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
